import { Component, Input, OnInit } from '@angular/core';
import { Location } from '../../../../models/location';

import { AuthService } from '../../../../services/auth.service';
import { LocationService } from '../../../../services/location.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DistributionReportService } from '../../../../services/distribution-report.service';

@Component({
  selector: 'app-edit-location',
  templateUrl: './edit-location.component.html',
  styleUrls: ['./edit-location.component.css']
})
export class EditLocationComponent implements OnInit {
  @Input() company_Id: number;
  @Input() location_Id: number;
  @Input() distribution_Id: number;

  locationService: LocationService;

  locations: Location[];
  locationList: Location[];
  selectedLocation: Location;
  originalLocationId: number;

  init: boolean;

  constructor(authService: AuthService, public router: Router, private route: ActivatedRoute, locationService: LocationService,
    public distributionReportService: DistributionReportService) {
    this.locationService = locationService;
  }

  ngOnInit() {
    if (this.company_Id != undefined) {
      this.loadLocationData();
      this.init = true;
    }
  }

  updateSelectedLocation(event: any) {
    const location_Id = event.target.value;
    this.selectedLocation = this.locationList.filter(c => {
      return c.location_Id == location_Id;
    })[0];

    console.log("Selected ID: ")
    console.log(location_Id);

    console.log("Selected Location: ")
    console.log(this.selectedLocation);

    console.log("Selected Count: ")
    console.log(this.locationList.filter(c => {
      return c.location_Id == location_Id;
    }));

  }

  loadLocationData() {
    this.locationService.getAll(this.company_Id).then((data) => {
      this.locationList = data;
      this.locations = this.locationList;

      this.selectedLocation = this.locationList.filter(c => {
        return c.location_Id == this.location_Id;
      })[0];
      this.originalLocationId = this.selectedLocation.location_Id;
      /*if (this.is_client) {
        this.locations = this.locationList.filter(c => {
          return c.company_Id == this.filter.company_Id;
        });
      }*/
    });
  }

  saveLocation() {
    this.selectedLocation.distribution_Id = this.distribution_Id;
    this.distributionReportService.updateDistributionLocation(this.selectedLocation).then((data) => {
      console.log("Saved Location");
      console.log(data);
    });
  }


}
